'use client'

import { LuneTheme, useDevice } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import Asmpt from '@public/images/logos/asmpt.png'
import Astrazeneca from '@public/images/logos/astrazeneca.png'
import Brose from '@public/images/logos/brose.png'
import Festo from '@public/images/logos/festo.png'
import Freudenberg from '@public/images/logos/freudenberg.png'
import Lapp from '@public/images/logos/lapp-logo.png'
import Mahle from '@public/images/logos/mahle.png'
import Pmi from '@public/images/logos/pmi.png'
import Puma from '@public/images/logos/puma.png'
import Webasto from '@public/images/logos/webasto.png'

import LogosGrid from '@/components/LogosGrid'

const logos1 = [
    {
        name: 'PUMA',
        img: Puma,
        width: 78,
        height: 41.48,
    },
    {
        name: 'AstraZeneca',
        img: Astrazeneca,
        width: 148,
        height: 37,
    },
    {
        name: 'Philip Morris International',
        img: Pmi,
        width: 156,
        height: 35.73,
    },
    {
        name: 'Brose',
        img: Brose,
        width: 124,
        height: 32.9,
    },
    {
        name: 'Webasto',
        img: Webasto,
        width: 142,
        height: 28.82,
    },
]
const logos2 = [
    {
        name: 'MAHLE',
        img: Mahle,
        width: 102,
        height: 23.31,
    },
    {
        name: 'Freudenberg',
        img: Freudenberg,
        width: 177.94,
        height: 27.83,
    },
    {
        name: 'ASMPT',
        img: Asmpt,
        width: 151,
        height: 22.01,
    },
    {
        name: 'LAPP',
        img: Lapp,
        width: 138.37,
        height: 28.25,
    },
    {
        name: 'FESTO',
        img: Festo,
        width: 120.72,
        height: 22.63,
    },
]

const GrynLogos = ({ caption }: { caption?: string }) => {
    const { palette } = LuneTheme
    const { smScreen } = useDevice()
    return (
        <>
            <Box
                sx={{
                    position: 'relative',
                    '&:after': {
                        content: '""',
                        position: 'absolute',
                        bottom: 0,
                        left: '-50%',
                        right: '-50%',
                        height: '1px',
                        backgroundColor: `${palette.Grey300}`,
                        mx: {
                            lg: 37,
                            xl: 37,
                        },
                    },
                }}
            >
                {caption ? (
                    <Text
                        variant={'body2'}
                        sx={{ textAlign: 'center', pt: 6, color: palette.Grey900 }}
                    >
                        {caption}
                    </Text>
                ) : null}
                {smScreen ? (
                    <LogosGrid sx={{ pt: 6, pb: 6 }} logos={[...logos1, ...logos2]} />
                ) : (
                    <>
                        <LogosGrid sx={{ height: '120px', lineHeight: '120px' }} logos={logos1} />
                        <LogosGrid
                            sx={{ height: '120px', lineHeight: '120px', marginTop: '-48px' }}
                            logos={logos2}
                        />
                    </>
                )}
            </Box>
        </>
    )
}

export default GrynLogos
